import {
  Alert,
  alertClasses,
  Drawer,
  drawerClasses,
  styled,
} from "@mui/material";

const SheetContainer = styled(Drawer)`
  & .${drawerClasses.paper} {
    border-radius: 16px 16px 0px 0px;
  }
`;

const Note = styled(Alert)`
  &.${alertClasses.root} {
    background-color: #f4f4f4;
    color: #333333;
  }
  & .${alertClasses.icon} {
    color: #333333;
  }
`;

export { Note, SheetContainer };
